import React, { Component } from "react";
import { Route, Switch, BrowserRouter, Redirect } from "react-router-dom";
import MobileStatus from "./Component/mobileStatus";
import MobileStatusExplorer from "./Component/mobileStatusExplorer";
import Guide from "./Component/guide";
import BridgeAuthRoute from "./bridgeAuthRoutes";
import SignUpsExplorer from "./Component/signUpsExplorer";
import MobileDeviceExplorer from "./Component/mobileDeviceExplorer";
import SignUpsWithRegionExplorer from "./Component/signUpsWithRegionExplorer";
import LabsSignUpsExplorer from "./Component/labsSignUpsExplorer";
import JobsExplorer from "./Component/jobsExplorer";
import PaidExplorer from "./Component/paidExplorer";
import UpgradesExplorer from "./Component/upgradesExplorer";
import ConversationExplorer from "./Component/conversationsExplorer";
import ConversionsCombinedExplorer from "./Component/conversionsCombinedExplorer";
import TotalConversionsExplorer from "./Component/totalConversionsExplorer";
import TrialSignUpsWithRegionExplorer from "./Component/trialSignupsWithRegionExplorer";
import TrialSignUpsRepWithRegionExplorer from "./Component/trialSignupsRepWithRegionExplorer";
import TotalTrialsWithRegionExplorer from "./Component/totalTrialsWithRegionExplorer";
import TrialConversionsExplorer from "./Component/trialConversionsExplorer";
import TrialByRepExplorer from "./Component/trialByRepExplorer";
import TrialByPlanExplorer from "./Component/trialByPlanExplorer";
import TrialByAccountTypeExplorer from "./Component/trialByAccountTypeExplorer";
import TrialCancellationExplorer from "./Component/trialCancelationExplorer";
import TrialAccountsExplorer from "./Component/trialAccountsExplorer";
import ConversationWithDateChangeExplorer from "./Component/conversationsExplorer-date_change"; 

class Router extends Component{

 render(){
   return <BrowserRouter>
   <Switch>
     <BridgeAuthRoute path="/guide" Component={Guide}/>
     <BridgeAuthRoute path="/signups-explorer" Component={SignUpsExplorer}/>
     <BridgeAuthRoute path="/signupsByRegion-explorer" Component={SignUpsWithRegionExplorer}/>
     <BridgeAuthRoute path="/trialSignupsWithRegion-explorer" Component={TrialSignUpsWithRegionExplorer}/>
     <BridgeAuthRoute path="/trialSignupsByRepWithRegion-explorer" Component={TrialSignUpsRepWithRegionExplorer}/>
     <BridgeAuthRoute path="/totalTrialsWithRegion-explorer" Component={TotalTrialsWithRegionExplorer}/>
     <BridgeAuthRoute path="/trialByPlan-explorer" Component={TrialByPlanExplorer}/>
     <BridgeAuthRoute path="/trialAccountType-explorer" Component={TrialByAccountTypeExplorer}/>
     <BridgeAuthRoute path="/trialByRep-explorer" Component={TrialByRepExplorer}/>
     <BridgeAuthRoute path="/signupsLabs-explorer" Component={LabsSignUpsExplorer}/>     
     <BridgeAuthRoute path="/paid-explorer" Component={PaidExplorer}/>
     <BridgeAuthRoute path="/jobs-explorer" Component={JobsExplorer}/>
     <BridgeAuthRoute path="/mobile-stats" Component={MobileStatus}/>
     <BridgeAuthRoute path="/mobile-stats-explorer"  Component={MobileStatusExplorer}/>
     <BridgeAuthRoute path="/mobile-device-explorer"  Component={MobileDeviceExplorer}/>
     <BridgeAuthRoute path="/upgrades-explorer"  Component={UpgradesExplorer}/>
     <BridgeAuthRoute path="/conversions-explorer"  Component={ConversationWithDateChangeExplorer}/>
     <BridgeAuthRoute path="/trialConversions-explorer"  Component={TrialConversionsExplorer}/>
     <BridgeAuthRoute path="/conversions-combined-explorer"  Component={ConversionsCombinedExplorer}/>
     <BridgeAuthRoute path="/total-conversions"  Component={TotalConversionsExplorer}/>
     <BridgeAuthRoute path="/trialCancellation-explorer" Component={TrialCancellationExplorer}/>
     <BridgeAuthRoute path="/trialAccounts-explorer" Component={TrialAccountsExplorer}/>
     <Route exact path="/">
       <Redirect to="/guide" />
     </Route>

     <Route
          render={() => {
            window.location.href = "https://www.castingworkbook.com/404.html";
            return null;
          }}
        />
   </Switch>
   </BrowserRouter>
 }
}

export default Router;